<i18n lang="yaml">
en:
  discountMonth: 'from {0} month'
  discountYear: 'from 1 year'
ru:
  discountMonth: 'при оплате<br>от {0} месяцев'
  discountYear: 'при оплате<br>от 1 года'
</i18n>

<template>
  <s-section
    class="sales"
    :title="title"
    is-sub-section
  >
    <div class="sales__grid">
      <div class="sales__item">
        <strong>3%</strong>
        <span v-html="$t('discountMonth', [3])"></span>
      </div>
      <div class="sales__item">
        <strong>7%</strong>
        <span v-html="$t('discountMonth', [6])"></span>
      </div>
      <div class="sales__item sales__item--special">
        <strong>15%</strong>
        <span v-html="$t('discountYear', [6])"></span>
      </div>
    </div>
  </s-section>
</template>

<script>
export default {
  name: 'DedicatedSales',
  props: {
    title: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss">
.sales__title {
  max-width: 250px;

  @media (max-width: $breakpoint-xl) {
    max-width: none;
  }
}

.sales__grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);

  @media (max-width: $breakpoint-sm) {
    grid-template-columns: 1fr;
    grid-gap: 24px;
  }
}

.sales__item strong {
  display: block;
  margin-bottom: 24px;

  font-size: 88px;
  line-height: 70px;
  font-weight: 400;

  @media (max-width: $breakpoint-md) {
    margin-bottom: 16px;

    font-size: 48px;
    line-height: 40px;
  }
}

.sales__item--special strong {
  color: $secondary;
}
</style>